import React, { useMemo } from "react";
import { ResultCardCalloutProps } from "@usereactify/search";

export type CalloutProps = React.ComponentProps<NonNullable<ResultCardCalloutProps["render"]>>;

export const Callout: React.FC<CalloutProps> = ({ callout, itemRef, handleClick }) => {
  const hasMultipleLinks = useMemo(() => !!callout?.links?.length, [callout?.links]);
  const Component = useMemo(() => (hasMultipleLinks ? "div" : "a"), [hasMultipleLinks]);

  console.log(callout)

  return (
    <div
      className={`rs__result-card-callout col-span-${callout.displayColumns} row-span-${callout.displayRows}`}
      ref={itemRef}
      data-visibility={callout.visibility}
    >
      <Component
        className="rs__result-card-callout__link"
        onClick={handleClick}
        {...(!!callout.link && { href: callout.link })}
      >
        {callout.desktopVideo ? (
          <div className="rs__result-card-callout__video callout-desktop">
            <video playsInline loop muted autoPlay src={callout.desktopVideo} width="100%" />
          </div>
        ) : callout.desktopImage ? (
          <figure className="rs__result-card-callout__image callout-desktop">
            <img src={callout.desktopImage} width="100%" />
          </figure>
        ) : null}

        {callout.mobileVideo ? (
          <div className="rs__result-card-callout__video callout-mobile">
            <video playsInline loop muted autoPlay src={callout.mobileVideo} width="100%" />
          </div>
        ) : callout.mobileImage ? (
          <figure className="rs__result-card-callout__image callout-mobile">
            <img src={callout.mobileImage} width="100%" />
          </figure>
        ) : null}

        {callout.content && (
          <div
            className="rs__result-card-callout__content"
            style={{
              color: callout.textColor || undefined,
              backgroundColor: callout.backgroundColor || undefined,
            }}
          >
            <p>{callout.content}</p>

            {!!callout?.links?.length && (
              <div className="rs__result-card-callout__links">
                {callout?.links?.map((link) => (
                  <a className="rs__result-card-callout__link-btn" key={link.key} href={link.url}>
                    {link.content}
                  </a>
                ))}
              </div>
            )}
          </div>
        )}
      </Component>
    </div>
  );
};
